import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CasinoBetsService } from 'src/app/services/casino/casino-bets.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-andarbahar2-result',
  templateUrl: './andarbahar2-result.component.html',
  styleUrls: ['./andarbahar2-result.component.css']
})
export class Andarbahar2ResultComponent implements OnInit {
  details: any = {};
  win:any='';
  s_win:any = [];
  joker_win:any = "";
  joker_oddeven_win:any = "";
  joker_num_win:any = "";
  first_3_cards:any = "";
  array1: any = [];
  array2: any = [];
  casino_bets: any = [];
    filter_bets: any = [];
    totalbets: number = 0;
    totalAmount: number = 0;
    position_andar: number = 0;
    position_bahar: number = 0;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private casinoBetsService:CasinoBetsService,private router: Router, public dialogRef: MatDialogRef<any>, private fb: FormBuilder, private userService: UserService, private toasterService: ToastrService) { }

  ngOnInit(): void {
    this.dialogRef.updateSize('100%',);
    // this.getTeenPattiDetails();
    console.log('data',this.data);
    if(!this.data.acc_state){
      this.getTeenPattiDetails();
      }else{
        this.getCasinoResultonMarketId();
      }
      this.getCasinoBetsByMarketID();
  }

  getCasinoResultonMarketId(){
    this.casinoBetsService.getCasinoResultonMarketId(this.data.mid).subscribe((res:any)=>{
      console.log('res-->',res)
      if(res.length>0){
      const renamedObject = {
        ...res[0],          // Copy all existing properties
        desc: res[0].description, // Rename description to desc
        cards: res[0].result // Rename result to cards
      };
      console.log("renamedObject",renamedObject);
      this.getResults(renamedObject)
    }
    })
  }
 
  getTeenPattiDetails() {
    this.casinoBetsService.getTeenPattiDetails(this.data.mid).subscribe((res: any) => {
      // console.log('res',res);
      if(res.success){
        this.details = res.data;
        console.log('result', res.data);
        this.getResults(this.details[0]);
      }
    });
    this.getCasinoBetsByMarketID();
  }

  private getResults(data:any){
    this.win = data.win;
    this.divideIntoArrays(data.cards);
    // this.player1 = player1;
    // this.player2 = player2;
    let fc;
    if (data.cards.length > 0) {
      let cards = data.cards;
      let main_cards = cards.slice(0, 3);
      console.log(main_cards);
      for (let i = 0; i < main_cards.length - 1; i++) {
        if (main_cards[0].length == 4) {
          fc = main_cards[0].slice(0, 2);
        } else {
          fc = main_cards[0].charAt(0);
        }
        // console.log("main_cards[i+1]", main_cards[i + 1]);
        if (main_cards[i + 1].length != 4) {
          // console.log("for-->", main_cards[i + 1]);
          if (fc == main_cards[i + 1].charAt(0)) {
            i + 1 == 1 ? this.s_win.push('SB') : this.s_win.push("SA");
          }
        } else {
          if (fc == main_cards[i + 1].slice(0, 2)) {
            i + 1 == 1 ? this.s_win.push("SB") : this.s_win.push("SA");
          }
        }
      }
      console.log("main_cards.slice(1, 3)", main_cards.slice(1, 3));
      switch (main_cards.slice(1, 3)) {
        case "HH":
          this.joker_win = "Spade";
          break;
        case "CC":
          this.joker_win = "Club";
          break;
        case "DD":
          this.joker_win = "Heart";
          break;
        case "SS":
          this.joker_win = "Diamond";
          break;
      }
      let oddEvenCheck = main_cards[0];
      let firstCharacters;
      if (oddEvenCheck.length >= 4) {
        firstCharacters = oddEvenCheck.substring(0, 2);
      } else {
        firstCharacters = oddEvenCheck.charAt(0);
      }

      if (!isNaN(parseInt(firstCharacters))) {
        if (parseInt(firstCharacters) % 2 == 0) {
          this.joker_oddeven_win = "Even";
        } else {
          this.joker_oddeven_win = "Odd";
        }
      } else {
        switch (oddEvenCheck.charAt(0)) {
          case "A":
            this.joker_oddeven_win = "Odd";
            break;
          case "K":
            this.joker_oddeven_win = "Odd";
            break;
          case "Q":
            this.joker_oddeven_win = "Even";
            break;
          case "J":
            this.joker_oddeven_win = "Even";
            break;
        }
      }
      this.joker_num_win =  firstCharacters;
      
    }
    let Fst_Bet_winners = [];
    if (this.s_win.includes("SA")) {
      Fst_Bet_winners.push("SA");
      Fst_Bet_winners.push("1st BetA");
    }
    if (this.s_win.includes("SB")) {
      Fst_Bet_winners.push("SB");
      Fst_Bet_winners.push("1st BetB");
    }
      console.log("this.joker_win", this.joker_win);
      console.log("this.joker_oddeven_win", this.joker_oddeven_win);
      console.log("s_win", this.s_win);
      console.log("this.joker_num_win", this.joker_num_win);
  }

  private divideIntoArrays(cards:string) {
    console.log('cards----->',cards);
    const cardArray = cards.split(",");

    // Leave the first three cards
    this.first_3_cards = cardArray.slice(0, 3);

    // Start from the fourth card
    const remainingCards = cardArray.slice(3).filter(card => card !== "1");
    // Create two arrays
    // const array1 = [];
    // const array2 = [];

    remainingCards.forEach((card, index) => {
      if (index % 2 === 0) {
        this.array2.push(card); // Even indices go to array2
      } else {
        this.array1.push(card); // Odd indices go to array1
      }
    });

    console.log("First Three Cards:", typeof this.first_3_cards);
    console.log("Array 1:", this.array1);
    console.log("Array 2:", this.array2);

    // var asteriskIndex = inputString.indexOf('*');
    // var part1 = inputString.substring(0, asteriskIndex - 1);
    // var part2 = inputString.substring(asteriskIndex + 2);
    // var array1 = part1.split(',');
    // var array2 = part2.split(',');
    // console.log(array1,array2);
    // return [array1, array2];
  }
   getCasinoBetsByMarketID() {
        this.casinoBetsService.getCasinoBetsByOnlyMarketId(this.data.mid).subscribe((res: any) => {
            // console.log('filter_bets data', res);
            this.casino_bets = res;
            this.filter_bets = this.casino_bets;
            this.totalbets = this.casino_bets.length;
            this.totalAmount = this.casino_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
        });
    }

    translateLeft(type:any) {
      
      if(type=="andar"){
      if (this.position_andar > -900) {
        this.position_andar -= 60;
      }
      console.log(this.position_andar)
    }else if(type=='bahar'){
      if (this.position_bahar > -900) {
        this.position_bahar -= 60;
      }
      console.log(this.position_bahar)
    }
    }
  
    // Translate right in +300px increments until reaching 0px
    translateRight(type:any) {
      if(type=="andar"){
      if (this.position_andar < 0) {
        this.position_andar += 60;
      }
    }else if(type=='bahar'){
      if (this.position_bahar < 0) {
        this.position_bahar += 60;
      }
    }
    }

    filterBetsByType(event: any) {
        const filterType = (event.target as HTMLInputElement).value;
        console.log('filterType', filterType);
        if (filterType === 'all') {
            this.filter_bets = this.casino_bets;
        } else if (filterType === 'deleted') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.from === "deleted");
        } else if (filterType === 'Back') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Back");
        }
        if (filterType === 'Lay') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Lay");
        }
        this.totalbets = this.filter_bets.length;
        this.totalAmount = this.filter_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
    }

  closeDialog() {
    this.dialogRef.close();
  }

  dismiss() {
    this.dialogRef.close();
  }

}
